<!-- 리더십 > 안전리더십 관리 상세 > 상세설정 -->
<template>
  <div class="content-wrap">
    <NaviBox02/>
    <div class="tit-group02">
      <h2 class="tit">안전리더십 관리 상세</h2>
    </div>
    <div class="content-box">
      <div class="form-group col-ty">
        <!--form-row-->
        <div class="form-row">
          <div class="txt-tit">{{t('message.title')}}<span class="imp">*</span></div>
          <div class="row">
            <c-Input :placeholder="t('message.enterTitle')" class="size07" v-model="viewInfo.leadershipTitle" :name="'leadershipTitle'"/>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty01">
          <div class="txt-tit">{{t('message.openDate')}}<span class="imp">*</span></div>
          <div class="row">
            <c-InputDate v-model="viewInfo.startDate" :name="'startDate'" :enableTimePicker="false" readonly="" />
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty02">
          <div class="txt-tit">{{t('message.endDate')}}<span class="imp">*</span></div>
          <div class="row">
            <c-InputDate v-model="viewInfo.endDate" :name="'endDate'" :enableTimePicker="false" readonly="" />
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty01">
          <div class="txt-tit">{{t('message.participationTarget')}}자</div>
          <div class="row">
            <c-btn01 :btnText="t('message.add')" @click.prevent="onClickMemberPopup('1')"/>
            <v-btn class="txt03">{{viewInfo.leadershipTargets?viewInfo.leadershipTargets.length:'0'}}</v-btn>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty01">
          <div class="txt-tit">보고서열람대상</div>
          <div class="row">
            <c-btn01 :btnText="t('message.add')" @click.prevent="onClickMemberPopup('2')"/>
            <v-btn class="txt03">{{ viewInfo.reportTargets?viewInfo.reportTargets.length:'0' }}</v-btn>
          </div>
        </div>
        <!--form-row-->
        <div class="form-row ty01">
          <div class="txt-tit">변경정보</div>
          <div class="row">
            <v-btn class="txt03" @click="onClickChangeDialog">{{ viewInfo.historyCnt }}</v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box ty01">
      <div class="sort-group">
        <div class="sort-row">
          <div class="wl">
            <div class="txt04">안전리더십 과제 설정</div>
          </div>
          <div class="wr">
            <c-btn01 :btnText="'단계추가'" @click.prevent="onClickAdd"/>
          </div>
        </div>
      </div>
      <div class="sortable-group02">
        <div class="sortable-header">
          <div class="col">노출<br>순서</div>
          <div class="col">{{t('message.stage')}}</div>
          <div class="col">{{t('message.title')}}</div>
          <div class="col">집중<br>관리</div>
          <div class="col">
            평가<br>가중치<br>
            <span>총{{totalScore}}</span>
          </div>
          <div class="col">상세<br>설정</div>
          <div class="col">{{t('message.delete')}}</div>
        </div>
        <draggable
          v-model="viewInfo.leadershipTasks"
          item-key="idx"
          tag="div"
          class="sortable-cont"
          animation="200"
          @end="onChange"
        >
          <template #item="{element, index}">
            <div class="draggable" :key="element.idx">
              <div class="row">
                <div class="col" aria-hidden="true">
                  <img src="@/assets/img/format-align-justify.svg" alt="">
                </div>
                <div class="col">
                  {{ index+1 }}
                </div>
                <div class="col">
                  <div class="form-group">
                    <c-Input :placeholder="'단계명'" v-model="element.taskTitle" :name="`title_${element.idx}`" :disabled="true"/>
                    <c-Input :placeholder="'상세설명'" v-model="element.taskDescription" :name="`content_${element.idx}`" :disabled="true"/>
                  </div>
                </div>
                <div class="col">
                  <div class="check-group">
                    <v-checkbox v-model="element.reportYn" true-value="Y" false-value="N" @click="onClickReportYn(element, $event)"></v-checkbox>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <c-Input :placeholder="''" class="size06" :name="'evaluationRatio'+index" :type="'number'" :min="0" :max="100" v-model="element.evaluationRatio" :disabled="element.reportYn!='Y'" />
                  </div>
                </div>
                <div class="col">
                  <BtnIcon class="btn-ico-set" @click="onClickSetting(element)"/>
                </div>
                <div class="col">
                  <BtnIcon class="btn-ico-delete" @click="onClickDelete(element)"/>
                </div>
              </div>
            </div>
          </template>
        </draggable>
        <div class="sortable-footer">
          <div class="col">총합</div>
          <div class="col">총 <span>{{ totalScore }}</span></div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 :btnText="t('message.list')" @click.stop="onClickGoList()"/>
      </div>
      <div class="wr">
        <!-- <c-btn02 :btnText="t('message.preview')" @click="onClickDetail"/> -->
        <c-btn02 :btnText="t('message.delete')" @click="dialogDeleteModel=true"/>
        <c-btn01 :btnText="t('message.save')" @click="handleForm"/>
      </div>
    </div>
  </div>
  <!--일괄 대상자 변경-->
  <DialogTargetAdd2
    v-model="dialogChangeModel"
    @close="dialogChangeModel=false "
    @confirm="confirmMember"
  />
  <!--popup: 변경이력-->
  <c-dialog v-model="dialogChangeHistoryModel"
            v-bind="dialogChangeHistoryBind"
            :dialogText="historyDialogText"
            @close="dialogChangeHistoryModel=false"
  />
  <!--popup: 상세설정-->
  <dialogSafetyDetailSet v-model="dialogSafetyDetailSetModel"
                         @close="dialogSafetyDetailSetModel=false"
                         @confirm="confirmSetting"
  />
  <!--popup: 미리보기-->
  <DialogPreview
    v-model="dialogPreviewModel"
    :pop-title="t('message.preview')"
    @close="dialogPreviewModel=false"
  />
  <!--popup: 삭제-->
  <c-dialog
    v-model="dialogDeleteModel"
    v-bind="dialogDeleteBind"
    @confirm="onClickDeleteLeadership"
    @close="dialogDeleteModel=false"
  />
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {Form, useForm} from "vee-validate";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import * as yup from "yup";
import _ from 'lodash';
import draggable from 'vuedraggable'
import dayjs from "dayjs";
import LogService from "@/services/log.service";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//validation schema
const schema = yup.object().shape({
  leadershipTitle: yup.string().required(() => t('message.requiredField')),
  startDate:yup.string().required(() => t('message.requiredField')),
  endDate:yup.string().required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx!='null'?route.params.idx:''
const dialogChangeModel = ref(false)
const dialogChangeHistoryModel = ref(false)
const dialogPreviewModel = ref(false)
const dialogSafetyDetailSetModel = ref(false)
const dialogDeleteModel = ref(false)
const viewInfo:any = ref({})  //전체정보
const historyDialogText = ref('')
let changeLog = []

//computed
const totalScore = computed(()=>{
    let returnScore = 0
    if(viewInfo.value.leadershipTasks) {
      const reportList = _.filter(viewInfo.value.leadershipTasks, {'reportYn': 'Y'})
      returnScore = _.sumBy(reportList, item => {
        const val = Number(item.evaluationRatio)
        return !isNaN(val) ? val : 0
      })
    }
    return returnScore
  }
)

//ui
const dialogChangeHistoryBind = {
  dialogTit: t('message.changeHistory'),
  dialogText: '생성 / admin / 2024.01.03 수정(제목) / admin / 2024.01.04<br>대상추가(3명) / admin / 2024.01.04<br>대상제거(1명) / admin / 2024.01.04<br>행동수정 / admin / 2024.01.04',
  btn1Text: t('message.confirm'),
  btn1Show: true,
}
const dialogDeleteBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}

//watch

//hook
onMounted(() => {
  if (!utils.isEmpty(viewIdx)) {
    getLeadership()
  }
})

//function
const getLeadership=async()=>{
  let params = {
    idx: viewIdx
  }

  try{
    const response = await LeadershipService.getLeadership(params)
    if (response.success) {
      viewInfo.value = response.result
      viewInfo.value.startDate = viewInfo.value.startDate ? dayjs(viewInfo.value.startDate).format('YYYY-MM-DD') : ''
      viewInfo.value.endDate = viewInfo.value.endDate ? dayjs(viewInfo.value.endDate).format('YYYY-MM-DD') : ''
      if(!_.some(changeLog, 'task'))
        changeLog.push('task')
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const getLeadershipTask=async(idx)=>{
  let params = {
    idx: idx
  }

  try{
    const response = await LeadershipService.getLeadershipTask(params)
    if (response.success) {
      return response.result
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const handleForm = async()=>{
  if(import.meta.env.MODE == 'development') {
    onClickGoList()
  }
  else{
    const result = await validate(); // 전체 필드 검증 실행
    if(!result.valid)
      return

    const reportList = _.filter(viewInfo.value.leadershipTasks, {'reportYn':'Y'})

    if(totalScore.value != 100){
      snackText.value = t('message.evaluationWeight100Alert')
      snackbar.value = true
      return
    }

    try {
      const result = await insertLeadership()
      utils.movePage('/safetyLeadershipManagement')
    }
    catch (e) {
      utils.log(e)
    }
  }
}
const onClickGoList = ()=>{
  utils.movePage('/safetyLeadershipManagement')
}

const onClickMemberPopup = (type)=>{
  storeRef.popupType.value = type
  storeRef.moduleType.value = "2"
  //선택된 리더십 task
  storeRef.selectedTask.value = null
  //리더십 타겟
  if(type == '1')
    storeRef.popupItems2.value = viewInfo.value.leadershipTargets
  else if(type == '2')
    storeRef.popupItems2.value = viewInfo.value.reportTargets

  //회원정보에서 대상맴버정보 넘겨서 사용, 양쪽다 포함될수 없어서 막는 용도로 사용, 리더십에서는 사용안해서 초기화
  storeRef.popupItemsExtra.value = []
  //팝업오픈
  dialogChangeModel.value=true
}

const confirmMember = (params)=>{
  dialogChangeModel.value=false
  if(params !== false) {
    if(storeRef.popupType.value == '1') {
      viewInfo.value.leadershipTargetCnt = params.length
      viewInfo.value.leadershipTargets = params
      if(!_.some(changeLog, 'targetMember'))
        changeLog.push('targetMember')
    }
    else if(storeRef.popupType.value == '2') {
      viewInfo.value.reportTargetCnt = params.length
      viewInfo.value.reportTargets = params
      if(!_.some(changeLog, 'reportMember'))
        changeLog.push('reportMember')
    }
  }
}

const onClickDetail = ()=>{
  if(import.meta.env.MODE == 'development') {
    dialogPreviewModel.value=true
  }
  else{
    //사용안하는듯 일단 주석
    //storeRef.popupIdx.value = viewIdx
    //선택된 리더십 task
    storeRef.selectedTask.value = viewInfo.value.leadershipTasks
    dialogPreviewModel.value=true
  }
}

const insertLeadership = async ()=>{
  try {
    let companyIdx = localStorage.getItem('companyIdx')
    viewInfo.value.companyIdx = companyIdx
    viewInfo.value.changeLogList = changeLog
    const response = await LeadershipService.insertLeadership(JSON.parse(JSON.stringify(viewInfo.value)))
    if (response.success) {
      return response
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch (error) {
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onClickAdd = async ()=>{
  //신규면 생성필요함
  try {
    if(utils.isEmpty(viewIdx)){
      const result = await validate()
      if(!result.valid)
        return

      const insertRes:any = await insertLeadership()
      if (insertRes.success) {
        viewIdx = insertRes.result.idx
        await getLeadership()
      }
      else{
        snackText.value = insertRes.message
        snackbar.value = true
        return
      }
    }

    let companyIdx = localStorage.getItem('companyIdx')
    let leadershipIdx = viewIdx
    let params = {
      companyIdx: companyIdx,
      leadershipIdx: leadershipIdx
    }
    const response:any = await LeadershipService.insertLeadershipTask(params)
    if (response.success) {
      let cnt = viewInfo.value.leadershipTasks?viewInfo.value.leadershipTasks.length + 1:1
      viewInfo.value.leadershipTasks.push({...response.result, step:cnt})
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onClickChangeDialog = ()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    tableType: 'leadership',
    parentIdx:viewIdx
  }
  LogService.getLogList(params).then(
    (response) => {
      let logContent = ''
      if(response.result.length > 0) {
        response.result.forEach(function(row) {
          logContent += `${row.changeLog} / ${row.memberId} / ${dayjs(row.regDate).format('YYYY-MM-DD HH:mm:ss')} <br>`
        });
      }

      if(logContent != '') {
        historyDialogText.value = utils.changeLogLanguage(logContent)
        dialogChangeHistoryModel.value=true
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickSetting = (item)=>{
  //선택된 리더십 task
  storeRef.selectedTask.value = item
  //리더십 전체정보
  storeRef.leadershipInfo.value = viewInfo.value
  dialogSafetyDetailSetModel.value = true
}

//상세설정 팝업 emit
const confirmSetting = (item)=>{
  //굳이 리프래쉬 안해도됨
  //getLeadership()
}

const onClickDelete = async (item)=>{
  const task:any = await getLeadershipTask(item.idx)
  if(task.contentCnt > 0){
    snackText.value = '과제의 상세단계가 존재하여 삭제 실패하였습니다'
    snackbar.value = true
    return
  }
  let params = {
    idx: item.idx,
    delYn: "Y"
  }
  await insertLeaderShipTask(params)
  _.remove(viewInfo.value.leadershipTasks, item)
}

const onClickReportYn = async (item, event)=>{
  let params = {
    idx: item.idx,
    reportYn: event.target.checked?'Y':'N',
    evaluationRatio: event.target.checked?item.evaluationRatio:0,
    taskChangeYn: 'Y'
  }
  await insertLeaderShipTask(params)
  if(!event.target.checked) {
    let checkedRow = _.find(viewInfo.value.leadershipTasks, {idx: item.idx})
    checkedRow.evaluationRatio = 0
  }
}

const insertLeaderShipTask = async (params) => {
  try{
    const response = await LeadershipService.insertLeadershipTask(params)
    if (response.success) {
      //await getLeadership()
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const deleteLeaderShip = async () => {
  try{
    const response = await LeadershipService.deleteLeadership({idx:viewInfo.value.idx})
    if (response.success) {
      utils.movePage('/safetyLeadershipManagement')
    } else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const onClickDeleteLeadership = async ()=>{
  if(viewInfo.value.leadershipTasks.length > 0){
    snackText.value = '과제의 단계가 존재하여 삭제 실패하였습니다'
    snackbar.value = true
    return
  }
  await deleteLeaderShip()
  dialogDeleteModel.value=false
}


const onChange = () => {
  console.log('최종 순서:', viewInfo.value.leadershipTasks.map(v => v.idx))
}
</script>



<style lang="scss" scoped>
.sortable-group02{
  .sortable-header ,.sortable-cont .draggable{
    .col:nth-child(1){flex-grow:0;width:5%;}
    .col:nth-child(2){flex-grow:0;width:5%;}
    .col:nth-child(3){justify-content:flex-start;text-align:left}
    .col:nth-child(4){flex-grow:0;width:5%;}
    .col:nth-child(5){flex-grow:0;width:15%;}
    .col:nth-child(6){flex-grow:0;width:5%;}
    .col:nth-child(7){flex-grow:0;width:5%;}
  }
  .sortable-footer{
    .col:nth-child(1){flex-grow:0;width:16%;}
    .col:nth-child(2){flex-grow:0;width:27%;}
  }
}

</style>
